import React, { useEffect, useState, useMemo } from 'react'
import { useAccessToken } from '@salesforce/commerce-sdk-react'
import useCustomFetch from '../../../../hooks/useFetchContent'
import { Box, Text } from '@chakra-ui/react'
import { toolTipContainer, headerPromoContainer, topArrowStyle } from './index.style'
import Slider from "react-slick";
const slotIDs = 'header-promotion-banner';

const HeaderPromotionBanner = () => {
    const { token } = useAccessToken()
    const { response, loading, error } = useCustomFetch(token, slotIDs, true)
    const [slidesContent, setSlidescontent] = useState([])
    const [tooltipContentToShow, setTooltipContentToShow] = useState('')
    const [showTooltip, setShowtooltip] = useState(false);

    const sliderSettings = useMemo(() => ({
        dots: true,
        infinite: true,
        arrows: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: !showTooltip,
        autoplaySpeed: 2000,
        fade: true,
        beforeChange: (index1, index2) => {
            if (slidesContent[index1]) {
                const slide = slidesContent[index1];
                if (slide.popContent) {
                    setTooltipContentToShow(slide.popContent);
                } else if (showTooltip) {
                    setShowTooltip(true);
                }
            }
        }
    }), [showTooltip]);

    useEffect(() => {
        if (response) {
            const parser = new DOMParser()
            const responseHtml = parser.parseFromString(response, 'text/html')
            const slideElements = responseHtml.querySelectorAll('#headPromoSlider > p')
            if (slideElements.length) {
                const slidesArray = Array.from(slideElements).map((slide) => {
                    return {
                        html: slide.innerHTML,
                        popContent: slide.dataset.popupContent
                    }
                })
                setSlidescontent(slidesArray)
            }
        }
    }, [response])

    if (error || loading || !response || slidesContent.length === 0) return

    const handleTooltipContent = (e, tooltipContent) => {
        if (tooltipContent) {
            e.preventDefault()
            setTooltipContentToShow(tooltipContent)
            setShowtooltip(true)
        }
    }

    const closeTooltip = () => {
        setShowtooltip(false)
    }

    return (
        <Box id="header-promotion-banner" sx={headerPromoContainer}>
            <Box className="header-promotion" id="insidePromo">
                <Box id="headPromoSlider">
                    {slidesContent.length === 1 ? (
                        <Text
                            as="p"
                            m="0"
                            onClick={(e) => handleTooltipContent(e, slidesContent[0].popContent)}
                            dangerouslySetInnerHTML={{ __html: slidesContent[0].html }}
                        ></Text>
                    ) : (
                        <Box id="homepage-slides">
                            <Slider key={showTooltip} {...sliderSettings}>
                                {slidesContent.map((slideHtml, index) => (
                                    <Text
                                        key={index}
                                        as="p"
                                        m="0"
                                        onClick={(e) => handleTooltipContent(e, slideHtml.popContent)}
                                        dangerouslySetInnerHTML={{ __html: slideHtml.html }}

                                    ></Text>
                                ))}
                            </Slider>
                        </Box>
                    )}
                </Box>
            </Box>
            <Box sx={toolTipContainer} display={showTooltip ? 'block' : 'none'}>
                <Box sx={topArrowStyle}></Box>
                <Text as="span" onClick={closeTooltip}>
                    x
                </Text>
                <Text as="p" dangerouslySetInnerHTML={{ __html: tooltipContentToShow }}></Text>
            </Box>
        </Box>
    )
}
export default HeaderPromotionBanner;
